package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.react.StyleUtil
import com.neurobs.ccabserver.transcriptreview.states.{EngineWordStateProvider, RecordingSegment, RecordingTranscriptReviewStateGenerator, TestTranscriptReviewStateGenerator}
import com.neurobs.ccabserver.transcriptreview.util.{NonEditableTranscript, NonEditableTranscriptWord}
import com.neurobs.util.TimeSeconds
import org.scalajs.dom.{AudioBuffer, console}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html._

@react
object EngineTranscript {

  case class Props(audioDuration: TimeSeconds, engineTranscript: NonEditableTranscript)

  val component = FunctionalComponent[Props] { props =>

    val recordingState = RecordingTranscriptReviewStateGenerator.accessState
    val testState = TestTranscriptReviewStateGenerator.accessState

    def isHighlighted = recordingState.highlightedEngine.value == props.engineTranscript.engineIdentifier
//    val (isHighlighted, setIsHighlighted) = useState(false)

//    useEffect(() => {
//      console.log(recordingTranscriptReviewState.highlightedEngine.value == props.engineTranscript.engineIdentifier)
//      if (recordingTranscriptReviewState.highlightedEngine.value == props.engineTranscript.engineIdentifier) setIsHighlighted(true)
//      else setIsHighlighted(false)
//    }, Vector(recordingTranscriptReviewState.highlightedEngine.value))


    def generateStyle = {
      StyleUtil.makeStyle(
        ("width", testState.secondsToPixels(props.audioDuration)),
        ("transformOrigin", "0 0"),
        ("transform", testState.getTransformStyle),
        ("marginBottom", "5px"),
        ("boxShadow", if (isHighlighted) "0px 0px 10px 5px #2b7bcc" else ""),
        ("height", "20px"),
        ("overflow", "hidden")
      )
    }

    def engineWordComponent(engineWord: NonEditableTranscriptWord, wordIndex: Int) = {
      EngineWordStateProvider(props.engineTranscript, engineWord, recordingState, testState)(
        EngineWord()
      ).withKey(wordIndex.toString)
    }

    div(
      style := generateStyle
    )(
      props.engineTranscript.nonEditableTranscriptWords.zipWithIndex.map(zipped => {
        engineWordComponent(zipped._1, zipped._2)
      })
    )
  }
}
